import React from "react";
import { COMPANY } from "../data/site";
import { Phone, MessageCircle } from "lucide-react";

const FloatingActions = () => {
  const m = COMPANY.contacts[0];
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3" data-testid="floating-actions">
      <a
        href={`https://wa.me/${m.whatsapp}`}
        target="_blank"
        rel="noreferrer"
        data-testid="float-whatsapp"
        className="w-12 h-12 rounded-full bg-green-500 hover:bg-green-600 grid place-items-center shadow-xl shadow-green-500/30 transition-colors"
        aria-label="WhatsApp"
      >
        <MessageCircle className="w-5 h-5 text-white" />
      </a>
      <a
        href={`tel:${m.phone}`}
        data-testid="float-call"
        className="w-12 h-12 rounded-full heat-gradient grid place-items-center shadow-xl shadow-red-500/30"
        aria-label="Call"
      >
        <Phone className="w-5 h-5 text-white" />
      </a>
    </div>
  );
};

export default FloatingActions;
